import type {SitePreferencesResponse} from '../helpers/customSitePreferences'
import {Mapping, InferredPreferences} from './site-preferences.types'
import {transformPreferences} from '../helpers/transformPreferences'

export const SERVER_PREFERENCE_MAPPING = {
    Bloomreach: {
        br_integration_id: {
            id: 'br_integration_id',
            type: 'string',
            defaultValue: ''
        },
        br_campaign_name: {
            id: 'br_campaign_name',
            type: 'string',
            defaultValue: ''
        },
        br_accountEdited_templateID: {
            id: 'br_accountEdited_templateID',
            type: 'string',
            defaultValue: ''
        },
        br_createAccount_templateID: {
            id: 'br_createAccount_templateID',
            type: 'string',
            defaultValue: ''
        },
        br_orderConfirmation_templateID: {
            id: 'br_orderConfirmation_templateID',
            type: 'string',
            defaultValue: ''
        },
        br_passwordReset_templateID: {
            id: 'br_passwordReset_templateID',
            type: 'string',
            defaultValue: ''
        },
        br_passwordChanged_templateID: {
            id: 'br_passwordChanged_templateID',
            type: 'string',
            defaultValue: ''
        },
        br_magicLink_templateID: {
            id: 'br_magicLink_templateID',
            type: 'string',
            defaultValue: ''
        }
    },
    'Storefront Configs': {
        customerServiceEmail: {
            id: 'customerServiceEmail',
            type: 'string',
            defaultValue: 'noreply@salesforce.com'
        }
    }
} as const satisfies Mapping

export type ServerSitePrefs = InferredPreferences<typeof SERVER_PREFERENCE_MAPPING>

export const toServerPreferences = (prefs: SitePreferencesResponse): ServerSitePrefs => {
    return transformPreferences<ServerSitePrefs>(
        prefs,
        SERVER_PREFERENCE_MAPPING as Mapping,
        'Server'
    )
}
